import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';           // adjust if your home component is named/indexed differently
import Contact from './pages/Contact';     // ok if you have it; can remove if not
import Booking from './pages/Booking';
import Checkout from './pages/Checkout';
import Thanks from './pages/Thanks';

export default function App(){
  return (
    <div>
      <header style={{padding:'12px 20px', borderBottom:'1px solid #eee', display:'flex', gap:16}}>
        <Link to="/">Home</Link>
        <Link to="/booking" className="cta">Book</Link>
        <Link to="/contact">Contact</Link>
      </header>

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/thanks" element={<Thanks />} />
        </Routes>
      </main>
    </div>
  );
}
